import type { BeneficialOwnerResponse } from '@gcv/shared';

import { getPossibleManagingBeneficialOwner } from './get-possible-managing-beneficial-owner';

export const getManagingBeneficialOwner = (
  beneficialOwners: BeneficialOwnerResponse[],
  templateResultId: string
): BeneficialOwnerResponse | undefined => {
  const possibleOwners = getPossibleManagingBeneficialOwner(beneficialOwners, templateResultId);

  return possibleOwners.length === 1 ? possibleOwners[0] : undefined;
};
